import React from 'react';
import { Link } from 'react-router-dom';
import { useIsKenya, getPhoneDisplay } from '../hooks/useIsKenya';
import { useGeoLocation } from '../hooks/useGeoLocation';
function FacebookIcon({
  size = 20
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" data-id="element-35">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-36" />
    </svg>;
}
function InstagramIcon({
  size = 20
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" data-id="element-37">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-38" />
    </svg>;
}
function XIcon({
  size = 20
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" data-id="element-39">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-40" />
    </svg>;
}
function LinkedInIcon({
  size = 20
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" data-id="element-41">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-42" />
    </svg>;
}
export function Footer() {
  const isKenya = useIsKenya();
  const phoneDisplay = getPhoneDisplay(isKenya);
  const {
    geo
  } = useGeoLocation();
  const phoneInternational = '+254 701 660 306';
  const socialLinks = [{
    name: 'Facebook',
    href: 'https://www.facebook.com/belodigitalke/',
    icon: FacebookIcon
  }, {
    name: 'Instagram',
    href: 'https://www.instagram.com/belodigital_/',
    icon: InstagramIcon
  }, {
    name: 'X',
    href: 'https://x.com/belo_digital',
    icon: XIcon
  }, {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/belodigital/',
    icon: LinkedInIcon
  }];
  return <footer className="bg-[#00316B] text-white pt-16 pb-8" data-id="element-43">
      <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        {/* Main content — two columns: logo left, contact right */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-45">
          {/* Left: Logo + description */}
          <div data-id="element-46">
            <Link to="/" className="block mb-6" data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/qZq5o2kR7qajKU24kpFCJC/blogo.svg" alt="Belo Digital" className="h-10 w-auto brightness-0 invert" data-id="element-48" />
            </Link>
            <p className="text-white/70 text-base leading-relaxed max-w-sm" data-id="element-49">
              We help businesses across Africa and the world embrace the digital
              age with confidence. Creative designs, functional websites,
              effective marketing and corporate media solutions – we make going
              digital simple, smart and impactful.
            </p>
          </div>

          {/* Right: Contact details + Social icons — pushed down to align with description */}
          <div className="md:ml-auto md:pt-16" data-id="element-50">
            <div className="space-y-3 text-base text-white/80" data-id="element-51">
              <p data-id="element-52">
                Email:{' '}
                <a href="mailto:biz@belo.co.ke" className="hover:text-white transition-colors" data-id="element-53">
                  biz@belo.co.ke
                </a>
              </p>
              <p data-id="element-54">
                Call:{' '}
                <a href="tel:+254701660306" className="hover:text-white transition-colors" data-id="element-55">
                  {phoneDisplay}
                </a>
              </p>
              <p data-id="element-56">
                WhatsApp:{' '}
                <a href={`https://wa.me/254701660306`} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-57">
                  {phoneDisplay}
                </a>
              </p>
            </div>

            {/* Social media icons — real brand logos */}
            <div className="flex items-center gap-4 mt-6" data-id="element-58">
              {socialLinks.map(social => {
              const Icon = social.icon;
              return <a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.name} className="text-white/60 hover:text-white transition-colors" data-id="element-59">
                    <Icon size={20} data-id="element-60" />
                  </a>;
            })}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/15" data-id="element-61" />

        {/* Bottom bar */}
        <div className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-white/50" data-id="element-62">
          <p data-id="element-63">
            &copy; {new Date().getFullYear()} Belo Digital. All rights reserved.
          </p>
          <div className="flex items-center gap-1.5" data-id="element-64">
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-65">
              Terms of Use
            </Link>
            <span className="text-white/30" data-id="element-66">|</span>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-67">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}